import React from 'react';

const BizOsArrows = () => {
    return (
        <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 4H13.2M13.2 4L10.32 1M13.2 4L10.32 7" stroke="#00A7B5" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M13.2 11L0.999996 11M0.999996 11L3.88 14M0.999996 11L3.88 8" stroke="#00A7B5" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" />
        </svg>

    );
}

export default BizOsArrows;
